export const TRANSFER_OMS_COMMAND_PENDING = "TRANSFER_OMS_COMMAND_PENDING";
export const TRANSFER_OMS_COMMAND_REJECTED = "TRANSFER_OMS_COMMAND_REJECTED";
export const TRANSFER_OMS_COMMAND_FULFILLED = "TRANSFER_OMS_COMMAND_FULFILLED";
export const CLEAR_TRANSFER_OMS_COMMAND = "CLEAR_TRANSFER_OMS_COMMAND";



// WEBPACK FOOTER //
// ./src/constants/transferOmsCommand.js